import { useCallback, useState } from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import TrailerOutlineIcon from "../../../../../../common/icons/TrailerOutlineIcon";
import {
  Card,
  Dialog,
  DialogTitle,
  Divider,
  Button as MuiButton,
} from "@material-ui/core";
import { ChangeSelectedEventsTrailerForm } from "./ChangeSelectedEventsTrailerForm";

interface Props {
  selectedRows: number[];
  currentTrailers?: Array<string | null | undefined>;
  latestEvent?: number;
  shouldRenderReactAdminButton?: boolean;
}

export const ChangeEventsTrailer = ({
  selectedRows,
  currentTrailers,
  latestEvent,
  shouldRenderReactAdminButton = true,
}: Props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const handleFailed = useCallback(() => setDialogOpen(false), []);
  const handleSuccess = useCallback(() => {
    setDialogOpen(false);
    notify(
      "resources.hos-driver-log-view.messages.changeEventsTrailersSuccess",
      {
        type: "success",
      }
    );
    refresh();
  }, [refresh, notify]);

  return (
    <>
      {shouldRenderReactAdminButton ? (
        <Button
          className="master-action"
          label="Change trailer..."
          onClick={() => setDialogOpen(true)}
        >
          <TrailerOutlineIcon />
        </Button>
      ) : (
        <MuiButton
          color="primary"
          variant="text"
          onClick={() => setDialogOpen(true)}
          startIcon={<TrailerOutlineIcon />}
        >
          Change trailer
        </MuiButton>
      )}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Change trailer(s) for {selectedRows.length} event(s)
        </DialogTitle>
        <Divider />
        <Card>
          <ChangeSelectedEventsTrailerForm
            selectedRows={selectedRows}
            latestEvent={latestEvent}
            currentTrailers={currentTrailers}
            onSuccess={handleSuccess}
            onFailed={handleFailed}
          />
        </Card>
      </Dialog>
    </>
  );
};
